import { createSelector } from 'reselect'
import getPayableAfterModifiers from './getPayableAfterModifiers'
import { floatify } from 'lib/maths/mathUtils'

const getGiftCardPayableAmount = createSelector(
  (state: App.State) => getPayableAfterModifiers(state),
  (state: App.State) => state.redeemedGiftCards.cards,
  (state: App.State) => state.checkout.cart.currencyCode,
  (
    payable,
    redeemedCards,
    currencyCode,
  ): number => {
    // Calculate total amount of redeemed gift cards for the current currency
    const giftCardBalance = redeemedCards
      .filter(card => card.currencyCode === currencyCode)
      .reduce((total, card) => total + parseFloat(String(card.amount)), 0)

    const maxGiftCardTotal = Math.min(giftCardBalance, payable)

    return floatify(maxGiftCardTotal)
  },
)

export default getGiftCardPayableAmount
